var TRANSLATIONS = TRANSLATIONS || {};
// franzoesisch ---------------------------
TRANSLATIONS.fr = {
  MATH: {
    FRACTION: '.'
  },
  OK: 'OK',
  YES: 'Qui',
  NO: 'Non',
  TITLE: 'Olivio configurateur',
  PREVIOUS: 'retour',
  NEXT: 'continuer',
  CLOSE: 'fermer',
  RESET: 'réinitialiser',
  CANCEL: 'annuler',
  APPLY: 'appliquer',
  LOGIN: 'connexion',
  LOGOUT: 'déconnexion',
  LOAD: 'charger',
  WARNING: 'avertissement',
  DOWNLOAD1: 'finaliser la configuration et',
  DOWNLOAD2: 'générer la fiche technique',
  PLEASE_ASK: 'sur demande',
  STEPS: {
    PRODUCT: 'ligne de design',
    DESIGN: 'forme',
    CHARGING: 'borne de recharge',
    ASSEMBLY: 'caractéristiques techniques',
    DISTRIBUTION: 'caractéristiques techniques',
    COLOR: 'caractéristiques techniques',
    POWER: 'caractéristiques techniques',
    DETAILS: 'détails',
    CHECKOUT: 'check out'
  },
  DESIGN: {
    SIDEVIEW: 'choisir mât et hauteur du point lumineux',
    TOPVIEW: 'choisir numéro et disposition des tête des luminaires',
    CHOOSE_BOOM: 'choisir les bras',
    CHOOSE_LUMINAIRE: 'choisir la taille du luminaire',
    NOCHOOSE_LUMINAIRE: 'taille du luminaire',
    LUMINAIRES: 'têtes',
    DESIGN: 'design',
    MAST_TYPE: 'mât',
    MAST_HEIGHT: 'hauteur du mât',
    LUM_HEIGHT_TOP: 'hauteur maximale du point lumineux',
    LUM_HEIGHT_BOTTOM: 'hauteur minimale du point lumineux',
    LUM_HEIGHT: 'hauteur du luminaire',
    DEGREE_START: 'angle initial',
    DEGREE_ROTATION: 'segment d\'angle',
    DEGREE_LUM: 'angle de la tête du luminaire',
    LUM_NUMBER: 'quantité de têtes du luminaire',
    MAST_MATERIAL: 'matériau du mât', // TODO von jemand nativen prüfen lassen
    MAST_MATERIAL_HOLZ: 'bois',
    MAST_MATERIAL_METALL: 'métal',
    COLOR: 'couleur',
    COLOR_ALL: 'couleur du mât, du corps de la luminaire ou du Inlay',
    COLOR_OUTSIDE: 'couleur du mât ou du corps de la luminaire',
    COLOR_WOODPOLE: 'bois du mât',
    COLOR_MAST: 'couleur du mât',
    COLOR_INLAY: 'couleur Inlay',
    COLOR_LUM: 'couleur',
    BOOM_TYPE: 'type de bras',
    LUM_TYPE: 'type de têtes du luminaire',
    COLOR_INFO: 'glisser-déposer dans les cases les couleurs souhaitées et cliquer sur appliquer.',
    UNITS: "unité",
    DOOR: "porte",
    TOPVIEWBACKGROUND: "images/design_topviewbg_fr.svg",
    ADVANCED_LOADCONFIG: "charger la configuration",
    ADVANCED_LEAVE: "quitter le mode expert",
    ADVANCED_SETTINGSLOST: "Les paramètres avancés seront perdus",
    BASE: "douille",
    GOBO: "choisir Gobo",
    CHOOSE_GOBO: "Choisir Gobo",
    GOBO_INFO_HEAD: 'Gobo',
    GOBO_INFO_STANDARD_HEAD: 'Standard (focale de 85mm)',
    GOBO_INFO_TELE_HEAD: 'Telephoto (focale de 150mm)',
    GOBO_INFO_WIDE_HEAD: 'Grand angle (focale de 63mm)',
    GOBO_INFO_EXTRAWIDE_HEAD: 'Très grand angle (focale de 45mm)',
    GOBO_INFO_STANDARD_TEXT: 'La lentille standard est utilisée par défaut '+
    'avec tout Olivio Gobo dans la plupart des cas. '+
    'Elle permet l\'obtention d\'une image d\'environ '+
    '4,5m de diamètre à une distance de '+
    'projection de 10m.',
    GOBO_INFO_TELE_TEXT: 'La lentille Telephoto permet '+
    'de projeter des images très '+
    'lumineuses à longues distances. '+
    'Une image d\'environ 2,5m de diamètre '+
    'peut ainsi être obtenue à une '+
    'distance de projection de 10m.'+
    '',
    GOBO_INFO_WIDE_TEXT: 'La lentille grand angle élargit les diamètres '+
    'd\'images projetées. En contrepartie, la '+
    'quantité de lumière projetée étant répartie sur une '+
    'plus large surface, l\'image perd en luminosité. '+
    'Elle permet l\'obtention d\'une image d\'environ 6,5m '+
    'de diamètre à une distance de projection de 10m.',
    GOBO_INFO_EXTRAWIDE_TEXT: ' La lentille très grand angle est'+
    'généralement utilisée lorsque la distance '+
    'entre l\'Olivio Gobo et la surface de '+
    'projection est très courte. Elle permet l\'obtention '+
    'd\'une image d\'environ 8,75m de diamètre à une '+
    'distance de projection de 10m.',
    GOBO_INFO_LOOKBOOK: 'Lookbook',
    GOBO_INFO_LOOKBOOK_URL: ' http://www.selux.com/lookbook/olivio-gobo-en_ger/',
    CHARGING_NUMBER: 'quantité de bornes de recharge',
    CHARGING_TYPE: 'type de bornes de recharge',
    CHARGING_POWER: 'puissance de chargement',
    ANCHOR: 'base à enfouissement',
    ANCHOR_WO: 'sans',
    ANCHOR_WITH: 'avec'

  },
  CHARGING: {
    QUESTION: 'Voulez-vous ajouter une borne de recharge pour véhicule électrique?',
    TOPVIEW: 'choisir numéro et disposition des bornes de recharge',
    CHOOSE_TYPE: 'Modell wählen', // FIXME
    CHOOSE_POWER: 'kW wählen', // FIXME
    charging: 'borne de recharge',
    chargings: 'bornes de recharge',
    CHARGING_BASIC: 'Basique',
    CHARGING_ADV: 'Avancé',
    CHARGING_PROF: 'Professionnel',
    CHECKOUT: 'bornes de recharge'
  },
  ASSEMBLY: {
    TITEL: 'lamp',
    LED: 'LED',
    LED_DESCRIPTION: '',
    HIT: 'HIT',
    HIT_DESCRIPTION: '',
    CPO: 'CPO',
    CPO_DESCRIPTION: ''
  },
  DISTRIBUTION: {
    TITEL: 'distribution',
    ASYMETRIC: 'asymétrique',
    SPOT: 'Spot',
    MEDIUM: 'Medium',
    FLOOD: 'Flood',
    TYP2: 'Type II',
    TYP5: 'Type V'
  },
  GOBO: {
    TITEL: "Grande Gobo LED, Ø 205, couleur 6500K, puissance 49W",
    EXTRAWIDE: 'Très grand angle',
    WIDE: 'Grand angle',
    STANDARD: 'Standard',
    TELE: 'Telephoto'
  },
  COLOR: {
    TITEL: 'couleur',
    COL2700K: '2700K',
    COL2700K_DESCRIPTION: '',
    COL3000K: '3000K',
    COL3000K_DESCRIPTION: 'blanc chaud',
    COL4000K: '4000K',
    COL4000K_DESCRIPTION: 'blanc neutre',
    COL4200K: '4200K',
    COL4200K_DESCRIPTION: '',
    COL5300K: '5300K',
    COL5300K_DESCRIPTION: '',
    RGBW: 'RGBW',
    RGBW_DESCRIPTION: 'polychrome',
    MONOCHROME: 'monochrome',
    MONOCHROME_DESCRIPTION: '',
    INFO: 'a couleur de la lumière peut être choisie uniquement pour les sources LED.',
    BACK: 'changer lampe',
    SKIP: 'sauter'
  },
  POWER: {
    TITEL: 'puissance',
  },
  CHECKOUT: {
    SURCHARGE: 'supplément pour la couleur',
    OPENINBROWSSER: 'ouvrir cette configuration dans le navigateur',
    SPECSHEET: 'fiche technique',
    PRINT: 'imprimer',
    DOWNLOAD_PDF: 'PDF',
    DOWNLOAD_DXF_SIDE: 'page DXF',
    DOWNLOAD_DXF_TOP: 'DFX en haut',
    DOWNLOAD_DXF_ZIP: 'DFX',
    DOWNLOAD_LDT_ZIP: 'LDT',
    CUSTOMIZE: 'personnaliser',
    MANUAL: 'montage',
    CONFIGURATION: 'configuration du luminaire',
    CONFIGNUMBER: 'numéro de configuration',
    ARRANGMENT: 'disposition',
    SINGLELEVEL: 'sur un seul niveau',
    STAGGERDLEVEL: 'sur plusieurs niveaux',
    SEEPAGETWO: 'détails voir page 2',
    CONTACTINTRO: 'pour plus d\'informations ou configurations individuelles n\'hésitez pas à nous contacter.',
    REQUESTQUOTE: 'Demander une offre personnalisée',
    INFOLINE1: 'Des modifications sont possibles en raison du développement et de l\'évolution constante de la technologie LED.',
    INFOLINE2: 'Selux GmbH, Sous réserve de modifications techniques 03.2014',
    CONTACTLINE1: 'Selux GmbH, Volkmarstr. 18, D-12099 Berlin, T +49 30 72001-0, F -100',
    LUMINAIRE: 'luminaire',
    BRACKET: 'bras',
    POLE: 'mât',
    WOODPOLE: 'mât en bois',
    HEIGHT: 'hauteur',
    DIAMETER: 'diamètre',
    DEGREE_ROTATION: 'angle',
    LAMP: 'source',
    COLOR: 'couleur',
    POWER: 'puissance',
    DISTRIBUTION: 'distribution',
    DRILLINTRO: 'fixation des luminaires à partir de la tête de mât',
    DRILLINTROFLORACION: 'Leuchtenanschluss von Mastunterkante (ohne Fußplatte)',
    HOLENUM: 'point de raccordement',
    HOLELUMHEIGHT: 'hauteur du point lumineux',
    HOLEHEIGHT: 'forage de fixation',
    HOLEANGLE: 'rotation',
    COMPANY: 'Société',
    CONTACT: 'Contact',
    PHONE: 'téléphone',
    EMAIL: 'e-mail',
    PROJECTNAMEID: 'nom/numéro du projet',
    PROJECTNAME: 'nom du projet',
    PROJECTID: 'numéro du projet',
    PROJECTADDRESS: 'adresse du projet',
    PROJECTNOTE: 'commentaire du projet',
    MESSAGE: 'Votre message',
    STREET: 'rue',
    NR: 'nr.',
    CITY: 'Ville',
    ZIP: 'CP' ,
    COUNTRY: 'Pays',
    SEND: 'envoyer',
    CLOSE: 'fermer',
    SENDING: 'envoi',
    SENDINGSUCCESS: 'demande envoyée',
    SENDINGERROR: 'Échec de l\'envoi!',
    ARTICLENUMBER: 'numéro de l\'article',
    PRICE: 'prix',
    PIECES: 'pièce',
    SUM: "total",
    DISPLAYPRICES: "afficher les prix",
    DISPLAYNUMBERS: "afficher les numéros des articles",
    DISPLAYDRILLHOLES: "afficher les forage de fixation pour la production",
    CONFIRMATIONHEAD: "costumer‘s conformation",
    CONFIRMATIONSIGNATURE: "signature/stamp/date",
    GOBO_LENS: 'Lentille',
    ANCHOR: 'base à enfouissement'
  },
  PRICE: {
    SUBTOTAL: 'Total intermédiaire Brut',
    PIECES: 'pièce'
  },
  COLORS: {
    SELUXGRAPHITE: 'Selux graphite',
    RAL9005: 'noir foncé',
    RAL7016: 'gris anthracite',
    RAL7024: 'gris graphite',
    RAL7011: 'gris fer',
    RAL9007: 'aluminium gris',
    RAL9006: 'aluminium blanc',
    RAL9010: 'blanc pur',
    RAL9016: 'blanc signalisation',
    RAL6009: 'vert sapin',
    RAL6005: 'vert mousse',
    RAL5003: 'bleu saphir',
    RAL3005: 'rouge vin',
    RAL3003: 'rouge rubis',
    DB703: 'gris foncé perle',
    DB702: 'gris argent perle',
    DB701: 'aluminium blanc perle',


    LIVERPOOL: 'Liverpool',
    SANSSOUCI: 'Sanssouci',
    VERSAILLE: 'Versaille',
    BLACKMATT: 'noir mat',

    WOOD_REDWOOD: 'Red Wood',
    WOOD_CANADIANBROWN: 'Canadian Brown',
    WOOD_COOLSCANDINAVIAN: 'Cool Scandinavian',
    WOOD_TENERIFFAGREY: 'Teneriffa Grey',
    WOOD_ROCKYMOUNTAINGREY: 'Rocky Mountain Grey',
    WOOD_HIMALAYAGREY: 'Himalaya Grey',
  },
  EOF: 'EOF'
};
